class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-b__dot'));
    this.index = 0;
    this.count = this.slides.length;
    if (this.count < 2) return;

    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.dots.forEach((dot) =>
      dot.addEventListener('click', () => {
        this.go(parseInt(dot.dataset.index, 10));
        this.restart();
      })
    );

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());

    // Pause when tab is hidden so the timer stays in sync
    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.stop() : this.start();
    });

    this.start();
  }

  go(target) {
    if (target === this.index) return;
    this.slides[this.index].classList.remove('is-active');
    this.dots[this.index] && this.dots[this.index].classList.remove('is-active');

    this.index = (target + this.count) % this.count;

    // Force reflow so the line-reveal animation replays each time a slide activates
    const next = this.slides[this.index];
    next.classList.remove('is-active');
    void next.offsetWidth;
    next.classList.add('is-active');
    this.dots[this.index] && this.dots[this.index].classList.add('is-active');
  }

  next() {
    this.go(this.index + 1);
  }

  start() {
    if (!this.autoplay || this.reduced || this.count < 2) return;
    this.stop();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }

  restart() {
    this.stop();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }
}

if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', HeroSlideshow);
}
